import { ChangeDetectionStrategy, Component, HostBinding, OnDestroy, OnInit } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { BreakpointObserver, Breakpoints } from "@angular/cdk/layout";
import { Subscription } from "rxjs";
import { views } from "@onsip/web/app/phone/views";
import { ShellNavigation } from "@onsip/web/features/shared/components/shellNavigations/shell-navigations.component";

@Component({
  selector: "onsip-pbx-settings",
  templateUrl: "./pbx-settings.component.html",
  styleUrls: ["./pbx-settings.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PbxSettingsComponent implements OnInit, OnDestroy {
  @HostBinding("class.onsip-grid-content")
  @HostBinding("class.onsip-admin-host-grid")
  _dontUse = true;

  constructor(
    private translate: TranslateService,
    private breakpointObserver: BreakpointObserver
  ) {}
  isMobile = false;
  showMobileNavigations = false;
  private unsubscriber = new Subscription();
  views = views;
  shellNavigations: Array<ShellNavigation> = [
    {
      name: this.translate.instant("ONSIP_I18N.PBX_CONTACT"),
      url: this.views.ADMIN_PBX_SETTINGS_CONTACT
    },
    {
      name: this.translate.instant("ONSIP_I18N.BLOCKED_NUMBERS"),
      url: this.views.ADMIN_PBX_SETTINGS_BLOCKED_NUMBERS
    },
    {
      name: this.translate.instant("ONSIP_I18N.DEFAULT_CALLER_ID"),
      url: this.views.ADMIN_PBX_SETTINGS_DEFAULT_CALLER_ID
    },
    {
      name: this.translate.instant("ONSIP_I18N.ENABLED_SERVICES"),
      url: this.views.ADMIN_PBX_SETTINGS_ENABLED_SERVICES
    },
    {
      name: this.translate.instant("ONSIP_I18N.MIGRATE_SIP_DOMAIN"),
      url: this.views.ADMIN_PBX_SETTINGS_MIGRATE_SIP_DOMAIN
    },
    {
      name: this.translate.instant("ONSIP_I18N.RECORDING_MANAGER"),
      url: this.views.ADMIN_PBX_SETTINGS_RECORDING_MANAGER
    },
    {
      name: "Storage Service",
      url: this.views.ADMIN_PBX_SETTINGS_STORAGE_SERVICE
    },
    {
      name: this.translate.instant("ONSIP_I18N.VOICEMAIL_MANAGER"),
      url: this.views.ADMIN_PBX_SETTINGS_VOICEMAIL_MANAGER
    }
  ];

  ngOnInit(): void {
    this.unsubscriber.add(
      this.breakpointObserver.observe(Breakpoints.XSmall).subscribe(result => {
        this.isMobile = result.matches;
      })
    );
  }

  ngOnDestroy(): void {
    this.unsubscriber.unsubscribe();
  }
}
